import { schema } from 'normalizr'

const shopProductOrderReview = new schema.Entity('shopProductOrderReviews', {})

export default shopProductOrderReview
